module.exports = __webpack_public_path__ + "img/TPV-L1-4-Pagina5 A-3.20ea6801.png";